import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrganizationRiderState } from './organization-rider.reducer';
import { OrganizationTypeCodeConstants } from '../../constants';
import { isNullOrUndefined } from '@uzurv/core';

export const organizationRiderState = createFeatureSelector<OrganizationRiderState>('organizationRider');

export const getNewItineraryStarted = createSelector(organizationRiderState, state => state.newItineraryStarted);

export const getVehicleTypes = createSelector(organizationRiderState, state => state.vehicleTypes);

export const getSelectedVehicleType = createSelector(organizationRiderState, state => state.selectedVehicleType);

export const isWavEnabled = createSelector(organizationRiderState, state => state.isWavEnabled);

export const isWavRideNowEnabled = createSelector(organizationRiderState, state => state.isWavRideNowEnabled);

export const isWavScheduledEnabled = createSelector(organizationRiderState, state => state.isWavScheduledEnabled);

export const isWavWillCallEnabled = createSelector(organizationRiderState, state => state.isWavWillCallEnabled);

export const isRideNowEnabled = createSelector(organizationRiderState, state => state.isRideNowEnabled);

export const isScheduledEnabled = createSelector(organizationRiderState, state => state.isScheduledEnabled);

export const isWillCallEnabled = createSelector(organizationRiderState, state => state.isWillCallEnabled);

export const isOnlyRideNowEnabled = createSelector(
  organizationRiderState,
  state => state.isRideNowEnabled && !state.isScheduledEnabled && !state.isWillCallEnabled
);

export const getAmenities = createSelector(organizationRiderState, state => state.amenities);

export const getRideRequestTypes = createSelector(organizationRiderState, state => state.rideRequestTypes);

export const getRideMetadataFields = createSelector(organizationRiderState, state => state.rideMetadataFields);

export const getOrganizationServiceLevels = createSelector(organizationRiderState, state => state.organizationServiceLevels);

export const getOrganizationRiderAddress = createSelector(organizationRiderState, state => state.organizationRiderAddress);

export const getSelectedAmenities = createSelector(organizationRiderState, state => state.selectedAmenitites);

export const getRider = createSelector(organizationRiderState, state => state.rider);

export const getRiderMobilityProfile = createSelector(organizationRiderState, state => state.riderMobilityProfile);

export const getOrganization = createSelector(organizationRiderState, state => state.organization);

export const getRiderPaymentAccounts = createSelector(organizationRiderState, state => state.riderPaymentAccounts);

export const getRideLimitDetail = createSelector(organizationRiderState, state => state.rideLimitDetail);

export const getLoadingRiderFavoriteLocations = createSelector(organizationRiderState, state => state.loadingRiderFavoriteLocations);

export const getRiderFavoriteLocations = createSelector(organizationRiderState, state => state.riderFavoriteLocations);

export const getOrganizationRiderServiceLevels = createSelector(organizationRiderState, state => state.organizationRiderServiceLevels);

export const getSearchString = createSelector(organizationRiderState, state => state.searchString);

export const getSearchingRider = createSelector(organizationRiderState, state => state.searchingRider);

export const getRiderAutocompleteResults = createSelector(organizationRiderState, state => state.autocompleteResults);

export const getAddingNewRider = createSelector(organizationRiderState, state => state.addingNewRider);

export const getItineraryDate = createSelector(organizationRiderState, state => state.itineraryDate);

export const getItineraryLegs = createSelector(organizationRiderState, state => state.itineraryLegs);

export const getReturnLegCreated = createSelector(organizationRiderState, state => state.returnLegCreated);

export const getSelectedPaymentAccount = createSelector(organizationRiderState, state => state.selectedPaymentAccount);

export const getAddingNewPaymentAccount = createSelector(organizationRiderState, state => state.addingNewPaymentAccount);

export const getItinerary = createSelector(organizationRiderState, state => state.itinerary);

export const getRideSubscription = createSelector(organizationRiderState, state => state.rideSubscription);

export const getIgnoredDrivers = createSelector(organizationRiderState, state => state.ignoredDrivers);

export const getFavoriteDrivers = createSelector(organizationRiderState, state => state.favoriteDrivers);

export const getLatestChargeOrder = createSelector(organizationRiderState, state =>
  state.riderPaymentAccounts && state.riderPaymentAccounts.length > 0
    ? state.riderPaymentAccounts[state.riderPaymentAccounts.length - 1].chargeOrder
    : 0
);

export const getOrganizationPaymentMethods = createSelector(organizationRiderState, state => state.organizationPaymentMethods);

export const getCardTypes = createSelector(organizationRiderState, state => state.cardTypes);

export const getNewPaymentAccount = createSelector(organizationRiderState, state => state.newPaymentAccount);

export const getOutstandingCharges = createSelector(organizationRiderState, state => state.outstandingCharges);

export const getPayments = createSelector(organizationRiderState, state => state.payments);

export const getExpandedPayment = createSelector(organizationRiderState, state => state.expandedPayment);

export const getExpandedPaymentTransactions = createSelector(organizationRiderState, state => state.expandedPaymentTransactions);

export const getLoadingTransactions = createSelector(organizationRiderState, state => state.loadingTransactions);

export const getSearchStringNewItinerary = createSelector(organizationRiderState, state => state.searchStringNewItinerary);

export const getSearchingRiderNewItinerary = createSelector(organizationRiderState, state => state.searchingRiderNewItinerary);

export const getAutocompleteResultsNewItinerary = createSelector(organizationRiderState, state => state.autocompleteResultsNewItinerary);

export const getCreatedOrganizationRiderSuccessfully = createSelector(
  organizationRiderState,
  state => state.createdOrganizationRiderSuccessfully
);

export const getSubmittingPaymentAccount = createSelector(organizationRiderState, state => state.submittingPaymentAccount);

export const getCustomerServiceNotes = createSelector(organizationRiderState, state => state.customerServiceNotes);

export const isOrganizationRiderAppEnabled = createSelector(organizationRiderState, state => state.organization?.riderAppEnabled);

export const isSendingUzurvRideAppInvitation = createSelector(organizationRiderState, state => state.sendingUzurvRideAppInvitation);

export const getAvailableProviders = createSelector(organizationRiderState, state => state.availableProviders);

export const getShouldShowPreferredProviderSelection = createSelector(
  organizationRiderState,
  state => state.shouldShowPreferredProviderSelection
);

export const getShouldShowPaymentSelection = createSelector(organizationRiderState, state => state.shouldShowPaymentSelection);

export const isRideSubscription = createSelector(organizationRiderState, state => state.isRideSubscription);

export const getRideSubscriptionStartDate = createSelector(organizationRiderState, state => state.subscriptionStartDate);

export const getUzurvRiderProfile = createSelector(organizationRiderState, state => state.uzurvRider);

export const getRiderProfileDetail = createSelector(organizationRiderState, state => state.riderProfileDetail);

export const getOrganizationRiderDetails = createSelector(organizationRiderState, state => state.organizationRiderDetails);

export const isLoadingRiderDetails = createSelector(organizationRiderState, state => state.loadingRiderDetails);

export const getUzurvRiderFullName = createSelector(organizationRiderState, state => state.uzurvRiderFullName);

export const getSelectedRiderDetailTab = createSelector(organizationRiderState, state => state.selectedRiderDetailTab);

export const getRiderTrips = createSelector(organizationRiderState, state => state.trips);

export const getTripsPageIndex = createSelector(organizationRiderState, state => state.tripsPageIndex);

export const getTripsPageSize = createSelector(organizationRiderState, state => state.tripsPageSize);

export const getShouldShowMobilityProfile = createSelector(organizationRiderState, state => state.shouldShowMobilityProfile);

export const getShouldDisableMobilityProfileSelection = createSelector(
  organizationRiderState,
  state => state.shouldDisableMobilityProfileSelection
);

export const getShouldDisableMobilityProfileSubmitButtons = createSelector(
  organizationRiderState,
  state => state.shouldDisableMobilityProfileSubmitButtons
);

export const isPerformingRiderSuspensionAction = createSelector(organizationRiderState, state => state.isPerformingRiderSuspensionAction);

export const isRiderSuspended = createSelector(
  organizationRiderState,
  state => state.rider?.suspended || state.organizationRiderDetails?.some(organizationRiderDetail => organizationRiderDetail.suspended)
);

export const hasActiveSuspensions = createSelector(
  organizationRiderState,
  state =>
    state.rider?.hasActiveSuspensions ||
    state.organizationRiderDetails?.some(organizationRiderDetail => organizationRiderDetail.hasActiveSuspensions)
);

export const getRiderSuspensions = createSelector(organizationRiderState, state => state.riderSuspensions);

export const getRiderNotFound = createSelector(organizationRiderState, state => state.riderNotFound);

export const getRiderIneligibleForOrganization = createSelector(
  getOrganizationRiderDetails,
  details => details?.some(d => !d.eligible) ?? false
);

export const getShowPaymentTabs = createSelector(
  getOrganizationRiderDetails,
  details => details?.some(d => d.riderPaymentAccountEnabled) ?? false
);
